import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef, OnInit } from '@angular/core';
import { NavigationServiceLink } from './navigation-service-link';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Component({
    selector: 'sample-tracking-side-nav',
    template: require('./navigation-service.component.html'),
    styles: [require('./navigation-service.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationServiceComponent implements OnInit {

    @Input()
    public topLevelMenu: NavigationServiceLink[] = [];

    @Input()
    public hasChildMenu = false;

    public expandChildNav = false;
    public currentLink: number;

    public queryParams: Observable<Params>;

    constructor(route: ActivatedRoute, private router: Router, public changeDetectorRef: ChangeDetectorRef) {
        this.queryParams = route.queryParams;
    }

    public ngOnInit() {
        if (!this.hasChildMenu) { return; }
        this.topLevelMenu.forEach((t, index) => {
            t.url.subscribe(value => {
                this.validateUrl(value, index);
                if (t.children) {
                    t.children.subscribe(childRoute => childRoute.forEach(route =>
                        route.url.subscribe(urlSegment => this.validateUrl(urlSegment, index, true))));
                }
            });
        });
    }

    public getToolTip(rootLink: NavigationServiceLink) {
        return rootLink.badgeToolTip ? rootLink.badgeToolTip : rootLink.text;
    }

    public rootLinkClick(rootIndex: number, route: NavigationServiceLink) {
        this.currentLink = rootIndex;
        this.expandChildNav = !route.children ? false : !this.expandChildNav;
    }

    public childLinkClick(rootIndex: number) {
        this.currentLink = rootIndex;
    }

    private validateUrl(urlSegment: string[], index: number, isChildMenu = false) {
        let url = '';
        urlSegment.forEach((segement, i) => {
            url = i > 0 && i + 1 !== urlSegment.length ? url + segement + '/' : url = url + segement;
        });
        if (url === this.router.url) {
            this.currentLink = index;
            this.expandChildNav = isChildMenu;
        }
    }
}